var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M23.3538 9.57117L13.3538 0.512803C13.3489 0.508708 13.3443 0.504297 13.34 0.499602C12.9718 0.178134 12.492 0 11.9944 0C11.4967 0 11.0169 0.178134 10.6488 0.499602L10.635 0.512803L0.64625 9.57117C0.442497 9.75105 0.279855 9.96958 0.168614 10.2129C0.057374 10.4563 -4.20536e-05 10.7191 2.31098e-08 10.9849V22.0798C2.31098e-08 22.5891 0.210714 23.0775 0.585786 23.4376C0.960859 23.7977 1.46957 24 2 24H8C8.53043 24 9.03914 23.7977 9.41421 23.4376C9.78929 23.0775 10 22.5891 10 22.0798V16.3193H14V22.0798C14 22.5891 14.2107 23.0775 14.5858 23.4376C14.9609 23.7977 15.4696 24 16 24H22C22.5304 24 23.0391 23.7977 23.4142 23.4376C23.7893 23.0775 24 22.5891 24 22.0798V10.9849C24 10.7191 23.9426 10.4563 23.8314 10.2129C23.7201 9.96958 23.5575 9.75105 23.3538 9.57117ZM22 22.0798H16V16.3193C16 15.8101 15.7893 15.3217 15.4142 14.9616C15.0391 14.6015 14.5304 14.3992 14 14.3992H10C9.46957 14.3992 8.96086 14.6015 8.58579 14.9616C8.21071 15.3217 8 15.8101 8 16.3193V22.0798H2V10.9849L2.01375 10.9729L12 1.91812L21.9875 10.9705L22.0012 10.9825L22 22.0798Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeInactive);
export default __webpack_public_path__ + "static/media/homeInactive.7716149644b219599bee3a3c5642849a.svg";
export { ForwardRef as ReactComponent };